import httpClient from '../httpClient';
import { SEARCH_PAGE_SIZE } from '../../constants/qr';

const isFilled = value => typeof value === 'string' && value.trim() !== '';

export function normalizeSearchResponse(data) {
    if (!data || !Array.isArray(data.content) || typeof data.last !== 'boolean') {
        throw new Error('Invalid resident search response');
    }
    return {
        items: data.content
            .filter(item => isFilled(item?.publicId) && isFilled(item?.displayName))
            .map(item => ({ id: item.publicId, displayName: item.displayName.trim() })),
        last: data.last,
    };
}

export async function searchResidents({ query, page = 0, size = SEARCH_PAGE_SIZE, intercomId, coordinates }) {
    const baseURL = process.env.VUE_APP_QR_INTERCOM_API_URL?.trim();
    if (!baseURL) throw new Error('QR intercom API URL is missing');
    if (typeof intercomId !== 'string' || !intercomId.trim()) throw new Error('QR intercom id is missing');
    if (!coordinates || ![coordinates.latitude, coordinates.longitude, coordinates.accuracy].every(Number.isFinite)) {
        throw new Error('Visitor location is missing');
    }
    const { latitude, longitude, accuracy } = coordinates;
    const { data } = await httpClient(baseURL)({
        method: 'POST',
        url: '/access/qr-intercom/residents/search',
        params: { page, size },
        timeout: 15000,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        data: { query, intercomId, latitude, longitude, accuracy },
    });
    return normalizeSearchResponse(data);
}
